module.exports = __webpack_public_path__ + "static/img/banner-img.509c4f7f.png";